import {ethers} from "ethers";
import { ChainProvider, ContractFacade } from "./abstact/ContractFacade";
import { VXProxyUserV2ABI } from "./abi/VXProxyUserV2ABI";
import { VXStrategyBotConfig, VXStrategyScope } from "./VXSManagerV2Contract";


export class VXProxyUserV2Contract extends ContractFacade
{
    constructor(address:string, provider:ChainProvider)
    {
        super(address, VXProxyUserV2ABI.GetABI(), provider);
    }

    async getBotConfig(ofAddress:string): Promise<VXStrategyBotConfig>
    {
        const result = await this._call("getBotConfig", ofAddress);
        if (!result) return;
        result.swapMaxSlippageIndex = this._toDecimal(result.swapMaxSlippageIndex);
        result.swapFrequencySeconds = parseInt(result.swapFrequencySeconds);
        result.splitFrequencySeconds = parseInt(result.splitFrequencySeconds);
        result.splitMinProfitAmount = this._toDecimal(result.splitMinProfitAmount);
        result.maxGasAmount = this._toDecimal(result.maxGasAmount);
        return result;
    }
}